module.exports = __webpack_public_path__ + "media/images/stanford_on_broadway/Dec18_Broadway_David_CR-p-800-5ba9dd5410308d8b9f1c99195d7c41c2.jpg";